// Core
import React, { useState, useRef, useEffect, Suspense } from 'react';
import { Flex, Box, Image, Text, useDisclosure } from '@chakra-ui/react';
import { MdToken } from 'react-icons/md';
import { SiSpeedtest } from 'react-icons/si';
import { FaOilCan } from 'react-icons/fa';
import { MdLeaderboard } from "react-icons/md";
import { FaBitbucket } from "react-icons/fa";
import { useLocation, useHistory } from "react-router-dom";
import { MdNetworkLocked } from "react-icons/md";

// Components
import StarsButton from '../Button/Button';
import { models } from '../Settings/Models.js';

const Footer = ({ tokens, setTokens, activeModel, setActiveModel, activeBuyPopup, setActiveBuyPopup }) => {

  const handleBack = () => {
    setActiveBuyPopup(false);
    setActiveModel(0);
  };

  const handleUnlock = () => {
    setActiveModel(activeModel);

    const setNewTokens = parseInt(localStorage.getItem('tokens') || 0, 10) - (models[activeModel ?? 0].price);
    setTokens(setNewTokens);
    localStorage.setItem('tokens', setNewTokens);
    localStorage.setItem(`unlockedModel_${activeModel}`, true);    

    setActiveBuyPopup(false);
  };

  return (
    <Box
      h={activeBuyPopup ? '50%' : '0%'}
      transition="0.3s all"
      position="absolute"
      bottom="0"
      width="100%"
      background="#00000059"
      backdropFilter="blur(4px)"
      borderRadius="36px 36px 0 0"
      borderTop="1px solid #ab1441"
      padding={activeBuyPopup ? '40px' : '0'}
      textAlign="center"
    >
        { tokens >= models[activeModel ?? 0].price ? (
          <Text>Unlock the stars! 🚀✨ 
            Purchase your 
            <span style={{ color: 'rgb(221, 22, 80)'}}> {models[activeModel ?? 0].name} </span> 
            for <span style={{ color: 'rgb(221, 22, 80)'}}> {models[activeModel ?? 0].price} </span>
            tokens and set off on an 
            intergalactic adventure.
            Upgrade, explore, and conquer the universe!
          </Text>
        ) : (
          <Text>
            Not enough tokens? 🚀 
            Keep playing and earn more to unlock your 
            <span style={{ color: 'rgb(221, 22, 80)'}}> {models[activeModel ?? 0].name} </span>
            for 
            <span style={{ color: 'rgb(221, 22, 80)'}}> {models[activeModel ?? 0].price} </span> tokens. 
            The galaxy awaits!
          </Text>
        )}

        { tokens >= models[activeModel ?? 0].price && (
          <StarsButton 
            text="unlock" 
            onClick={handleUnlock} 
            pt="0" 
            mt="-30px" />
        )}

        <StarsButton 
          text="back" 
          pt="0" 
          mt={ tokens >= models[activeModel ?? 0].price ? '-150px' : '-50px' }
          onClick={handleBack} 
          transform="scale(0.6)" />
    </Box>
  );
};

export default Footer;